import Footer from "@/components/navigation/Footer";
import NavBar from "@/components/navigation/NavBar";
import React from "react";
import GoogleTestimonials from "@/components/Landingpage/GoogleRating";
import { CalendarDateRangeIcon } from "@heroicons/react/24/outline";
import Reveal from "@/components/Motion/Reveal";
import FeaturesSectionVermieter from "@/components/design/FeaturesSectionVermieter";
import ContactModal from "@/components/design/ModalBeartungsTermin";
import ButtonStroke from "@/components/navigation/ButtonStroke";
import Proof from "@/components/proofs/Proof";
import ContactOptionsTabs from "@/components/calltoaction/CtaContact";
import VorteileSectionVermieten from "@/components/design/VorteileSectionVermieter";
import BeratungsterminModal from "@/components/form/BeratungsterminModal";
import ButtonPrime from "@/components/navigation/ButtonPrime";
import FaqSection from "@/components/navigation/faq";

export default function VermietenLandingpage() {
  return (
    <div className=" bg-white">
      <NavBar className="bg-opacity-100 border-none shadow-none" />

      <div className="pt-[3rem] px-2 mx-auto">
        <div className=" mx-auto px-4 sm:px-6 lg:px-8">
          <div className="md:grid flex flex-col-reverse max-w-[95rem] mx-auto md:grid-cols-2 py-10 gap-4 md:gap-8 xl:gap-20 md:items-center">
            <div className="md:pt-20 pt-10">
              <h1 className="block text-3xl font-serif font-bold text-dark-100 sm:text-3xl lg:text-5xl lg:leading-tight">
                 Vermietung, die Ihnen Zeit und Nerven spart.
              </h1>
              <p className="mt-3 text-lg text-gray-600">
              Sie möchten sicher vermieten, ohne sich um alles selbst kümmern zu müssen? Wir finden passende Mieter und begleiten Sie persönlich durch den gesamten Prozess.
              </p>
              <div className="mt-10">
                <BeratungsterminModal
                  trigger={
                    <ButtonPrime
                      onClick={() =>
                        umami.track(
                          `vermietenpage_hero_vor-ort-bewertung`,
                          "click"
                        )
                      }
                      className="w-full md:w-fit"
                      text="Jetzt Mieter finden"
                      icon={
                        <CalendarDateRangeIcon className="  size-8" />
                      }
                    />
                  }
                />
              </div>

              <div className="md:w-[33rem] mt-10">
                <Proof text="gray-500" />
              </div>
              <div className="mt-6 lg:mt-10 grid grid-cols-2 gap-x-5"></div>
            </div>
            <div className="relative h-full  ms-4">
              <img
                className="w-full h-full object-cover rounded-md"
                src="/Fotos/vermieten-hero-jakobs.jpg"
                alt="Hero Image"
              />
            </div>
          </div>
        </div>
        <div>
          <VorteileSectionVermieten />
        </div>

        <Reveal>
          <FeaturesSectionVermieter />
        </Reveal>

        <div className=" rounded-md py-10 md:px-5">
          <GoogleTestimonials />
        </div>
        <div></div>
      </div>
      <ContactOptionsTabs />
<div>
  <FaqSection faqArt="vermieten" />
</div>
      <Footer />
    </div>
  );
}
